import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `ACCT-PROFILE` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/profile/edit` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (QĐ PO 17/09 mục 12 — cụm tài khoản: hồ sơ).
 */
export const ACCT_PROFILE = {
  id: "ACCT-PROFILE",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Sửa hồ sơ CỦA BẠN trên toàn hệ thống: tên tài khoản, ảnh đại diện cá nhân, email. KHÔNG phải tên/ảnh của một NHÓM, cũng không phải tên hiển thị riêng trong một nhóm.",
    examples: [
      "sửa hồ sơ của tôi",
      "sua ho so cua toi",
      "đổi ảnh đại diện",
      "doi anh dai dien",
      "xác minh email",
      "đổi tên tôi",
      "hồ sơ",
      // ——— 0105: thêm cho đủ 40 ———
      "ho so",
      "doi ten toi",
      "xac minh email",
      "sửa thông tin cá nhân",
      "sua thong tin ca nhan",
      "đổi ảnh của tôi",
      "doi anh cua toi",
      "cập nhật hồ sơ cá nhân",
      "cap nhat ho so ca nhan",
      "thay ảnh đại diện mới",
      "thay anh dai dien moi",
      "tôi muốn đổi tên tài khoản",
      "toi muon doi ten tai khoan",
      "đổi email của tôi",
      "doi email cua toi",
      "mở trang cá nhân của tôi",
      "mo trang ca nhan cua toi",
      "thông tin tài khoản của tôi",
      "thong tin tai khoan cua toi",
      "tên tôi đang bị sai, sửa giúp",
      "ten toi dang bi sai sua giup",
      "đổi tên tài khoản kiểu gì?",
      "doi ten tai khoan kieu gi",
      "up ảnh đại diện",
      "up anh dai dien",
      "xác thực email của tôi",
      "xac thuc email cua toi",
      "sửa avatar cá nhân",
      "sua avatar ca nhan",
      "trang cá nhân",
      "chỉnh hồ sơ",
      "xem hồ sơ của mình",
      "doi anh ca nhan cua toi",
    ],
  },
  screen: "/profile/edit",
  screenShows: "profile_edit",
  endpoints: [
    "GET /me",
    "PATCH /me",
    "PUT /me/avatar",
    "POST /me/email/verify-request",
    "POST /me/email/verify",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở trang hồ sơ của bạn nhé.",
  },
  journey: { after: ["ACCT-LOGIN-LINKS"] },
  help: { title: "Hồ sơ của tôi", tryNow: "sửa hồ sơ của tôi" },
} satisfies AiCapabilityPage;
